// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__35tXC","signatureButtonsRight":"ModalSign_signatureButtonsRight__13GMp"};